import { useRouteContext } from '@tanstack/react-router';

export const useIsAuth = () => {
  const isAuth = useRouteContext({ from: '__root__', select: (state) => state.isAuth });

  return isAuth;
};

export const useAuthStatus = () => {
  return useRouteContext({ from: '__root__', select: (state) => state.authStatus });
};
